// Estilo "limpo" do mapa do Centro de Histórico (único lugar que usa
// Google Maps de verdade — mapa principal e editor de geocercas continuam
// em Leaflet). Fundo claro, ruas discretas, menos poluição visual (POIs/
// lojas/restaurantes ocultos), saturação reduzida, só vias principais em
// destaque.
//
// Só tem efeito quando NÃO há Map ID customizado configurado
// (VITE_GOOGLE_MAP_ID vazio) — o Google ignora este array de "styles" local
// quando o mapa usa um Map ID com estilo gerenciado na nuvem; nesse caso, o
// estilo é configurado direto no Google Cloud Console > Map Management.
export const GOOGLE_MAPS_CLEAN_STYLE: google.maps.MapTypeStyle[] = [
  { elementType: "geometry", stylers: [{ color: "#f8fafc" }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#64748b" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },

  { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },

  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "poi.business", stylers: [{ visibility: "off" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e8ede8", visibility: "on" }] },
  { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },

  { featureType: "road", elementType: "geometry", stylers: [{ color: "#e6e9ee", saturation: -60 }] },
  { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
  { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#dfe3e8" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#cbd5e1" }] },
  { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "on" }] },
  { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },

  { featureType: "transit", stylers: [{ visibility: "off" }] },

  { featureType: "water", elementType: "geometry", stylers: [{ color: "#dbeafe", saturation: -20 }] },
  { featureType: "water", elementType: "labels", stylers: [{ visibility: "off" }] },
];

// "DEMO_MAP_ID" é um valor público e documentado do próprio Google Maps
// Platform para desenvolvimento sem um Map ID customizado — necessário para
// habilitar Advanced Markers (usados para os marcadores do trajeto).
// Nunca é um ID fixo nosso: só entra em jogo quando VITE_GOOGLE_MAP_ID
// está vazio.
// Teste do mapa vetorial (2026-10-21): o Map ID próprio (vetorial) mudou o
// visual e fez os nomes piscarem em produção — voltou pro DEMO_MAP_ID. Pra
// testar sem afetar ninguém: abrir com ?mapa=vetorial (fica salvo neste
// navegador) e ?mapa=padrao pra voltar. O ID vem de VITE_GOOGLE_MAP_ID_TEST.
const TEST_KEY = "gd_map_vector_test";
function vectorTestOn(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const q = new URLSearchParams(window.location.search).get("mapa");
    if (q === "vetorial") localStorage.setItem(TEST_KEY, "1");
    if (q === "padrao") localStorage.removeItem(TEST_KEY);
    return localStorage.getItem(TEST_KEY) === "1";
  } catch {
    return false;
  }
}

function configuredMapId(): string {
  const test = (import.meta.env.VITE_GOOGLE_MAP_ID_TEST as string | undefined)?.trim();
  if (test && vectorTestOn()) return test;
  return ((import.meta.env.VITE_GOOGLE_MAP_ID as string | undefined) ?? "").trim();
}

export function resolveGoogleMapId(): string {
  return configuredMapId() || "DEMO_MAP_ID";
}

export function hasCustomGoogleMapId(): boolean {
  return !!configuredMapId();
}

// Parâmetros do deck.gl (luma v9) pros ícones dos veículos: sem teste de
// profundidade, sempre desenhados por cima do mapa. No modo interleaved
// (mapa vetorial) evita a briga de profundidade com ruas e nomes.
export const DECK_ON_TOP = { depthWriteEnabled: false, depthCompare: "always" } as const;
